// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import {application} from "./application"

import BrokerSidebarController from "./broker_sidebar_controller"

application.register("broker-sidebar", BrokerSidebarController)

import ClipboardController from "./clipboard_controller"

application.register("clipboard", ClipboardController)

import FlashController from "./flash_controller"

application.register("flash", FlashController)

import SubmitController from "./submit_controller"

application.register("submit", SubmitController)

import TagifyController from "./tagify_controller"

application.register("tagify", TagifyController)

import YearsToMonthsController from "./years_to_months_controller"

application.register("years-to-months", YearsToMonthsController)
